import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Facebook, Instagram, Youtube, Star, Cookie } from "lucide-react";
import { useSiteContent } from "../contexts/SiteContentContext";
import { STUDIO_ADDRESS } from "../lib/services";
import { useCookieConsent } from "../contexts/CookieConsentContext";

const LEGAL_LINKS = [
  { to: "/pravni/obchodni-podminky", label: "Obchodní podmínky" },
  { to: "/pravni/ochrana-osobnich-udaju", label: "Ochrana osobních údajů" },
  { to: "/pravni/cookies", label: "Cookies" },
  { to: "/pravni/reklamacni-rad", label: "Reklamační řád" },
  { to: "/pravni/reseni-sporu", label: "Řešení sporů" },
];

export default function Footer() {
  const { reopenSettings } = useCookieConsent();
  const { links } = useSiteContent();
  const SOCIALS = [
    { icon: Facebook, label: "Facebook", href: links.facebook },
    { icon: Instagram, label: "Instagram", href: links.instagram },
    { icon: Youtube, label: "YouTube", href: links.youtube },
    { icon: Star, label: "Google recenze", href: links.googleReviews },
  ].filter((s) => s.href);
  return (
    <footer className="relative overflow-hidden tone-footer" style={{ borderTop: "0.5px solid var(--linka-tmava)" }} data-testid="footer">
      <div className="lit-footer absolute inset-0 pointer-events-none" />
      <div className="max-w-[1180px] mx-auto px-[22px] md:px-8 py-14 grid md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div className="lg:col-span-1 md:col-span-2">
          <div className="font-display text-lg font-bold text-krem-100">Apex Detailing</div>
          <div className="text-akcent/90 t-label mt-1">Praha východ</div>
          <p className="mt-4 text-tlum-dark max-w-md text-sm leading-relaxed">
            Prémiový ruční detailing aut s přípravky Auto Finesse. Mobilní služba po celé Praze východ.
          </p>
          {SOCIALS.length > 0 && (
            <div className="mt-5 flex gap-3">
              {SOCIALS.map((s, i) => (
                <a
                  key={i}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className="w-9 h-9 rounded-full flex items-center justify-center text-tlum-dark hover:text-akcent transition-colors"
                  style={{ border: "0.5px solid var(--linka-tmava)" }}
                  data-testid={`footer-social-${s.label.toLowerCase().replace(/\s/g, "-")}`}
                >
                  <s.icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          )}
        </div>
        <div>
          <h4 className="t-h3 text-krem-100 mb-3">Navigace</h4>
          <ul className="space-y-2 text-sm text-tlum-dark">
            <li><a href="/#cenik" className="hover:text-akcent transition-colors">Ceník</a></li>
            <li><a href="/#o-mne" className="hover:text-akcent transition-colors">O mně</a></li>
            <li><a href="/#galerie" className="hover:text-akcent transition-colors">Galerie</a></li>
            <li><a href="/#jak-to-funguje" className="hover:text-akcent transition-colors">Jak to funguje</a></li>
            <li><a href="/#faq" className="hover:text-akcent transition-colors">FAQ</a></li>
          </ul>
        </div>
        <div>
          <h4 className="t-h3 text-krem-100 mb-3">Právní</h4>
          <ul className="space-y-2 text-sm text-tlum-dark" data-testid="footer-legal-links">
            {LEGAL_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="hover:text-akcent transition-colors" data-testid={`footer-legal-${l.to.split("/").pop()}`}>
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="t-h3 text-krem-100 mb-3">Kontakt</h4>
          <ul className="space-y-3 text-sm text-tlum-dark">
            <li className="flex gap-2"><Phone className="w-4 h-4 text-akcent mt-0.5" /> +420 604 447 377</li>
            <li className="flex gap-2"><Mail className="w-4 h-4 text-akcent mt-0.5" /> apexdetailingprague@gmail.com</li>
            <li className="flex gap-2">
              <MapPin className="w-4 h-4 text-akcent mt-0.5" />
              <a href={STUDIO_ADDRESS.mapsUrl} target="_blank" rel="noopener noreferrer" className="hover:text-akcent transition-colors">
                {STUDIO_ADDRESS.full}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="py-6 px-[22px] md:px-8 flex flex-wrap items-center justify-between gap-3 text-tlum-dark text-xs max-w-[1180px] mx-auto" style={{ borderTop: "0.5px solid var(--linka-tmava)" }}>
        <span>© {new Date().getFullYear()} Apex Detailing. Všechna práva vyhrazena.</span>
        <button
          type="button"
          onClick={reopenSettings}
          className="inline-flex items-center gap-1.5 hover:text-akcent transition-colors"
          data-testid="footer-cookie-settings"
        >
          <Cookie className="w-3.5 h-3.5" /> Nastavení cookies
        </button>
      </div>
    </footer>
  );
}
